import React, { useEffect, useState } from "react";
import BarChart from "./BarChart";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import {
  Button,
  Container,
  Divider,
  LinearProgress,
  TextField,
  Typography,
} from "@mui/material";
import LCPettyCash from "./LCPettyCash";
import BreakEvenPoint from "./BreakEvenPoint";
import PieChartOne from "./PieChartOne";
import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Charts = () => {
  const [fixedCost, setFixedCost] = useState(0);
  const [totalSale, setTotalSale] = useState(0);
  const [expenses, setExpenses] = useState(0);
  const [breakEven, setBreakEven] = useState(0);
  const [breakEvenAmount, setBreakEvenAmount] = useState(0);
  const [dateChart, setDateChart] = useState("");
  const [data, setData] = useState([]);
  const [dataPetty, setDataPetty] = useState([]);
  const [showChart, setShowChart] = useState(false);
  const [storeTotal, setStoreTotal] = useState(0);
  const [vanTotal, setVanTotal] = useState(0);

  var fx = 0;
  var dt = "";
  var breakEvenPorcentageValue = 0;
  var breakEvenAMount = 0;

  const globalFunction = async () => {
    const q = query(collection(db, "global1"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      fx = doc.data().fixedCost;
      dt = doc.data().dateChart;
    });
    setFixedCost(fx);
    setDateChart(dt);
  };

  const fetchData1 = async () => {
    const ref = collection(db, "pettyCash");
    const q = query(ref, where("date", ">", dateChart), orderBy("date", "asc"));
    const data = await getDocs(q);
    setDataPetty(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  const fetchData = async () => {
    breakEvenPorcentageValue = 0;
    breakEvenAMount = 0;
    const ref = collection(db, "register");
    const q = query(ref, where("date", ">", dateChart), orderBy("date", "asc"));
    const data = await getDocs(q);
    setData(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    breakEvenPorcentageValue = ((totalSale - fixedCost) / totalSale) * 100;
    setBreakEven(breakEvenPorcentageValue);
    breakEvenAMount = totalSale - fixedCost;
    setBreakEvenAmount(breakEvenAMount);
    fetchData1();
    setShowChart(true);
  };

  useEffect(() => {
    globalFunction();
  }, []);

  return (
    <>
      <Container>
        <Box>
          <Button onClick={fetchData}>Show Charts </Button>
        </Box>
        {showChart ? (
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "90vh",
              borderRadius: 20,
            }}
          >
            <Grid container spacing={2}>
              <Grid
                sx={{
                  background: "secondary",
                  color: "white",
                  borderRadius: "5px",
                }}
                item
                xs={12}
              >
                <Box
                  component="form"
                  sx={{
                    "& .MuiTextField-root": { m: 1, width: "25ch" },
                  }}
                  noValidate
                  autoComplete="off"
                >
                  <div>
                    <TextField
                      id="fixedCost"
                      label="Fixed Cost"
                      value={fixedCost}
                      defaultValue="0.00"
                      helperText="To update go to settings"
                    />
                    <TextField
                      id="sales"
                      label="Sales"
                      onChange={(e) => e.target.value}
                      value={parseFloat(totalSale).toFixed(2)}
                      helperText={dateChart}
                    />
                    <TextField
                      id="Expenses"
                      label="Expenses"
                      value={expenses}
                      helperText="Total expenses"
                    />
                    <TextField
                      id="break"
                      label="% Break even"
                      helperText={parseFloat(breakEven).toFixed(2)}
                      value={parseFloat(breakEvenAmount).toFixed(2)}
                      onChange={(e) => e.target.value}
                    />
                  </div>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <BarChart
                    totalSale={totalSale}
                    data={data}
                    setTotalSale={setTotalSale}
                    dateChart={dateChart}
                  />
                </Item>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <BreakEvenPoint
                    fixedCost={fixedCost}
                    dateChart={dateChart}
                    data={data}
                  />
                </Item>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <PieChartOne
                    dateChart={dateChart}
                    data={data}
                    setStoreTotal={setStoreTotal}
                    setVanTotal={setVanTotal}
                  />
                </Item>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <LCPettyCash dateChart={dateChart} dataPetty={dataPetty} />
                </Item>
              </Grid>
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "15vh",
                  borderRadius: 20,
                }}
              >
                <Container>
                  <Box>
                    <Typography variant="body2">
                      Store ${storeTotal.toFixed(2)}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={(storeTotal / totalSale) * 100}
                    />
                    <LinearProgress
                      variant="determinate"
                      value={(storeTotal / totalSale) * 100}
                    />
                    <LinearProgress
                      variant="determinate"
                      value={(storeTotal / totalSale) * 100}
                    />
                  </Box>
                  <Box>
                    <Typography variant="body2">
                      Van ${vanTotal.toFixed(2)}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={(vanTotal / totalSale) * 100}
                    />
                    <LinearProgress
                      variant="determinate"
                      value={(vanTotal / totalSale) * 100}
                    />
                    <LinearProgress
                      variant="determinate"
                      value={(vanTotal / totalSale) * 100}
                    />
                  </Box>
                </Container>
              </Box>
            </Grid>
          </Box>
        ) : (
          ""
        )}
      </Container>
    </>
  );
};

export default Charts;
